@let _fronts = fronts();

<section class="pb-7" [attr.aria-busy]="_fronts === null">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filterName]="filterName" [filters]="filters" />
    </div>
  }
  @if (_fronts === null) {
    <app-grid-skeleton
      gridClass="centered-with-padding grid grid-cols-2 gap-1.5 desk:grid-cols-4"
      itemClass="h-60 w-full desk:h-96"
      [count]="BREATHING_TEXT_INDEX" />
  } @else if (_fronts.length > 0) {
    <div class="centered-with-padding grid grid-cols-2 gap-1.5 desk:grid-cols-4">
      @for (front of _fronts; track index; let index = $index) {
        @if (index === BREATHING_TEXT_INDEX) {
          <div class="col-span-2 flex size-full items-center justify-center py-8 desk:p-6">
            <app-title [title]="{ text: data.breathingText, as: 'span' }" size="h2" />
          </div>
        }
        <div class="h-60 w-full desk:h-96">
          <app-option-card
            (imageClicked)="openVisualFullScreenModal(front.images[frontsImagesCurrentIndices()[index]!.current]!)"
            [image]="front.images[frontsImagesCurrentIndices()[index]!.current]!"
            imageCursorType="zoomIn">
            @if (front.images.length > 1) {
              <div
                (click)="$event.stopPropagation(); $event.preventDefault()"
                card-overlay-bottom
                class="flex cursor-default gap-x-2.5 p-2.5">
                <button (click)="updateImageIndex(index, -1)" class="rotate-180">
                  <app-svg [height]="13" [width]="20" src="assets/icons/arrow-right.svg" />
                </button>
                <button (click)="updateImageIndex(index, 1)">
                  <app-svg
                    [height]="13"
                    [inline]="true"
                    [width]="20"
                    class="text-white"
                    src="assets/icons/arrow-right.svg" />
                </button>
              </div>
            }
            <div card-title-left class="text-[14px] desk:text-[16px]">{{ front.title }}</div>
          </app-option-card>
        </div>
      }
    </div>
  } @else {
    <div class="centered-with-padding">{{ "COMPONENT.LISTING-FACADES.NO_RESULTS" | translate }}</div>
  }
</section>
